import { render } from "./TkEngagementInformationSnapshot.vue?vue&type=template&id=bc6cdeac&scoped=true"
import script from "./TkEngagementInformationSnapshot.vue?vue&type=script&lang=js"
export * from "./TkEngagementInformationSnapshot.vue?vue&type=script&lang=js"

import "./TkEngagementInformationSnapshot.vue?vue&type=style&index=0&id=bc6cdeac&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6cdeac"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
